import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Frat } from 'global-shared/models/frat.model';


@Component({
  selector: 'app-frat-dialog',
  templateUrl: './frat-dialog.component.html',
  styleUrls: ['./frat-dialog.component.css']
})
export class FratDialogComponent implements OnInit {

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: Frat
  ) { }

  ngOnInit(): void {
  }

}
